import React from 'react'
import { useTranslation } from 'react-i18next'
import config from '~/config'
import { authenticationStore } from '~/stores'
import { observer } from '~/ui/component'
import { ClearButton, HBox, Label, VBox } from '~/ui/components'
import { createUseStyles, layout, useTheme } from '~/ui/styling'
import { BeWizrOrganizationSwitcher } from '../bewizr'

export interface Props {}

const DrawerFooter = observer('DrawerFooter', () => {

  const theme = useTheme()
  const [t] = useTranslation()

  const oAuthProvider = authenticationStore.oAuthProvider

  const logOut = React.useCallback(() => {
    if (oAuthProvider == null) {
      authenticationStore.logOut()
    } else {
      // An oAuth logout endpoint needs to be called. Let the oAuth redirect page handle the logout.
      document.location.pathname = `/oauth/${oAuthProvider}/logout`
    }
  }, [oAuthProvider])

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <VBox classNames={$.DrawerFooter} padding={layout.padding.s} >
        <BeWizrOrganizationSwitcher/>
        <HBox justify='space-between'>
          {renderVersion()}
          {renderLogOut()}
        </HBox>
      </VBox>
    )
  }

  function renderVersion() {
    return (
      <Label dim tiny>
        {`v${config.version} (${config.environment})`}
      </Label>
    )
  }

  function renderLogOut() {
    return (
      <VBox>
        <ClearButton
          icon='logout'
          caption={t('auth:logout.caption')}
          color={theme.fg.dim}
          onTap={logOut}
          small
        />
      </VBox>
    )
  }

  return render()

})

export default DrawerFooter

const useStyles = createUseStyles(theme => ({
  DrawerFooter: {
    backgroundColor: theme.fg.normal.alpha(0.05),
    borderTopWidth:  1,
    borderTopColor:  theme.fg.normal.alpha(0.1),
  },
}))